/* eslint-disable no-unused-vars */
import { Card, Checkbox, FormControlLabel, Grid, Typography, FormControl, InputLabel, Select, MenuItem, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllVerifiedBotsForAPIReportsThunk, getAllVerifiedBotsToRunCampaignThunk } from "../../../redux/botManagement/botManagementThunk";
import { onRejectGetBotConversationLogsReportDetails } from "../../../redux/campaignReportsManagment/campaignReportsManagmentSlice";
import { apiGatewayAxiosInstance } from "../../../utils/axios";
import BotsList from "./BotsList";
import UserChats from "./UserChats";
import UsersList from "./UsersList";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useDebouncedValue } from "../../../hooks/useDebouncedValue";

export default function ConversationLogs() {
    // for bot type dropdown filter
    const [botType, setBotType] = React.useState("all");
    // for botName search filter
    const [searchQuery, setSearchQuery] = useState("");
    const [debouncedSearchQuery] = useDebouncedValue(searchQuery, 400, { leading: false }); // const campaignReportState = useSelector(state => state.campaignReportsManagementSlice);
    // const dispatch = useDispatch();
    const [selectedBot, setSelectedBot] = useState();
    const [selectedUserNumber, setSelectedUserNumber] = useState("");
    const [usersList, setUsersList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState(false);
    const [searchValue, setSearchValue] = useState("");

    const pageSize = 5;
    const [selectedUserDetails, setSelectedUserDetails] = useState([]);
    // const [selectedBotDetails, setSelectedBotDetails] = useState({});
    const [numberListOfUser, setNumberListOfUsers] = useState([]);
    const [pageNumber, setPageNumber] = useState(0);
    const [onlyButtonClickReport, setOnlyButtonClickReport] = useState(false);
    const [onlyReplyReport, setOnlyReplyReport] = useState(false);

    const now = dayjs();

    const [executedAtStartDate, setExecutedAtStartDate] = useState(
        dayjs().startOf("month").hour(now.hour()).minute(now.minute()).second(now.second()),
    );

    const [executedAtEndDate, setExecutedAtEndDate] = useState(dayjs());

    // const onSelectBot = botId => {
    //     setSelectedBotId(botId);
    //     setSelectedUserNumber("");
    //     const selectedBot = campaignReportState.botConversationLogsReportDetails.find(bot => bot.config.rbmClientId === botId);
    //     setSelectedBotDetails(selectedBot);

    //     let numbersList = [];

    //     for (let index = 0; index < selectedBot.otherDetails.reportDetails.length; index++) {
    //         const element = selectedBot.otherDetails.reportDetails[index];
    //         if (!numbersList.find(user => user.receiverNumber === element.receiverNumber)) {
    //             numbersList = [...numbersList, element];
    //         }
    //     }
    //     setNumberListOfUsers(numbersList);

    //     setUsersList(selectedBot.otherDetails.reportDetails);
    // };

    // const onSelectUser = userNumber => {
    //     setSelectedUserNumber(userNumber);
    //     const selectedNumberDetails = usersList.filter(user => user.receiverNumber === userNumber);
    //     setSelectedUserDetails(selectedNumberDetails);
    // };

    // useEffect(() => {
    //     getAllBotsConversationLogsReports();
    // }, []);

    // const onCloseErrorMessage = ({ fieldName }) => {
    //     dispatch(clearErrorMessagesForReports({ fieldName }));
    // };

    // const getAllBotsConversationLogsReports = async () => {
    //     try {
    //         dispatch(onPendingBotConversationLogsReportDetailsLoading(true));
    //         const response = await apiGatewayAxiosInstance.get(`/bot_management/bot/get-all-bot-conversation-logs`);
    //         if (response.status === 200) {
    //             dispatch(onSuccessBotConversationLogReportDetails(response.data.botListWithReportDetails));
    //         } else {
    //             throw new Error(response);
    //         }
    //     } catch (error) {
    //         let errorMessage = "Failed to get all logs.";

    //         if (error.response) {
    //             errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
    //         }
    //         dispatch(onRejectGetBotConversationLogsReportDetails(errorMessage));
    //     }

    // };
    const dispatch = useDispatch();

    const state = useSelector(state => state.botManagementSlice);
    // useEffect(() => {
    //     // dispatch(getAllVerifiedBotsThunk());
    //     dispatch(getAllVerifiedBotsToRunCampaignThunk());
    // }, []);
    useEffect(() => {
        // dispatch(getAllVerifiedBotsThunk());
        // dispatch(getAllVerifiedBotsToRunCampaignThunk());
        dispatch(
            getAllVerifiedBotsForAPIReportsThunk({
                currentPage: 0,
                pageSize: 10000,
                botNameSearchTerm: debouncedSearchQuery,
                botMessageType: botType,
                // if we set to "all" or leave it empty, it will fetch all api and non-api bots
                // other values are "true" and "false"
                showApiBots: "all",
            }),
        );
    }, [botType, debouncedSearchQuery, dispatch]);

    const onSelectBot = async bot => {
        setLoading(true);
        setSearchValue("");
        setSelectedUserNumber("");
        try {
            // const campaignReportDetailsResponse = await apiGatewayAxiosInstance.get(`conversation_logger/logger/get-numbers-by-botId`, {
            //     params: { botId: bot?.config?.rbmClientId },
            // });

            // if (campaignReportDetailsResponse.status === 200) {

            //     if (campaignReportDetailsResponse?.data?.NumberList) {

            //         setNumberListOfUsers(campaignReportDetailsResponse.data.NumberList);
            //     } else {
            //         setNumberListOfUsers([])
            //     }
            // }

            setSelectedBot(bot);

            setLoading(false);
        } catch (error) {
            let errorMessage = "Failed to get all logs.";
            setLoading(false);

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            dispatch(onRejectGetBotConversationLogsReportDetails(errorMessage));
        }
    };
    const onSelectUser = async number => {
        setLoadingMessage(true);
        setSelectedUserNumber(number);
        setPageNumber(0);
        try {
            const campaignReportDetailsResponse = await apiGatewayAxiosInstance.get(
                `conversation_logger/logger/get-conversation-logs-by-botId-number`,
                {
                    params: {
                        botId: selectedBot?.config?.rbmClientId,
                        number,
                        pageSize,
                        pageNumber: 0,
                        startDate: executedAtStartDate,
                        endDate: executedAtEndDate,
                    },
                },
            );

            if (campaignReportDetailsResponse.status === 200) {
                if (campaignReportDetailsResponse?.data?.ConversationLogs) {
                    setSelectedUserDetails(campaignReportDetailsResponse.data.ConversationLogs);
                } else {
                    setSelectedUserDetails([]);
                }
            }

            // setSelectedBot(bot);
        } catch (error) {
            let errorMessage = "Failed to get all logs.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            dispatch(onRejectGetBotConversationLogsReportDetails(errorMessage));
        }
        setLoadingMessage(false);
    };
    const onScrollTop = async NextpageNumber => {
        // setLoadingMessage(true)
        // setSelectedUserNumber(number)
        try {
            const campaignReportDetailsResponse = await apiGatewayAxiosInstance.get(
                `conversation_logger/logger/get-conversation-logs-by-botId-number`,
                {
                    params: {
                        botId: selectedBot?.config?.rbmClientId,
                        number: selectedUserNumber,
                        pageSize,
                        pageNumber: NextpageNumber,
                        startDate: executedAtStartDate,
                        endDate: executedAtEndDate,
                    },
                },
            );

            if (campaignReportDetailsResponse.status === 200) {
                if (campaignReportDetailsResponse?.data?.ConversationLogs) {
                    setSelectedUserDetails([...campaignReportDetailsResponse.data.ConversationLogs, ...selectedUserDetails]);
                }
            }

            // setSelectedBot(bot);
        } catch (error) {
            let errorMessage = "Failed to get all logs.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            dispatch(onRejectGetBotConversationLogsReportDetails(errorMessage));
        }
        // setLoadingMessage(false);
    };
    return (
        <Grid minHeight={"75vh"} maxHeight={"75vh"}>
            {/* <Card sx={{ marginBottom: "20px" }}> */}
            <Grid
                // sx={{
                //     // display: "flex",
                //     // padding: 3,
                //     display: "flex",
                //     // justifyContent: "space-between",
                //     flexDirection: "row",
                //     gap: 2,
                //     // padding: 5,
                // }}
                className="align-items-center"
            >
                <Grid item md={6} className="align-items-center">
                    <Typography variant="h3" paddingBlock={5} paddingInline={0}>
                        Conversation Logs
                    </Typography>
                </Grid>
            </Grid>

            {/* filters */}
            <Grid
                container
                spacing={2}
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    flexWrap: "wrap",
                }}
            >
                <Grid item xs={12} sm={6} md={4} lg={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Start Date"
                            value={executedAtStartDate}
                            onChange={value => {
                                setExecutedAtStartDate(dayjs(value));
                                setSelectedUserNumber("");
                            }}
                            format="DD-MM-YYYY"
                            name="startDate"
                            disableFuture
                            // sx={{
                            //     "& .MuiInputBase-root": {
                            //         height: "36px", // Adjust height for DatePicker
                            //         padding: "0 10px", // Adjust padding
                            //     },
                            // }}
                            slotProps={{
                                textField: { size: "small", fullWidth: true },
                            }}
                            sx={{
                                width: "100%",
                            }}
                        />
                    </LocalizationProvider>
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="End Date"
                            value={executedAtEndDate}
                            onChange={value => {
                                setExecutedAtEndDate(dayjs(value));
                                setSelectedUserNumber("");
                            }}
                            format="DD-MM-YYYY"
                            name="endDate"
                            disableFuture
                            // sx={{
                            //     "& .MuiInputBase-root": {
                            //         height: "36px", // Adjust height for DatePicker
                            //         padding: "0 10px", // Adjust padding
                            //     },
                            // }}
                            slotProps={{
                                textField: { size: "small", fullWidth: true },
                            }}
                            sx={{
                                width: "100%",
                            }}
                        />
                    </LocalizationProvider>
                </Grid>

                {/* search box for bot name */}
                {/* <Grid item xs={12} sm={6} md={4} lg={2}>
                    <TextField
                        value={searchQuery}
                        name="botName"
                        onChange={e => setSearchQuery(e.target.value)}
                        label="Bot Name"
                        placeholder="Enter Bot Name"
                        size="small"
                        fullWidth
                    />
                </Grid> */}

                {/* dropdown for bot type (promotional/transactional, by default show all) */}
                <Grid item xs={12} sm={6} md={4} lg={2}>
                    <FormControl fullWidth size="small">
                        <InputLabel id="bot-type-label">Select Bot Type</InputLabel>
                        <Select
                            labelId="bot-type-label"
                            id="bot-type-select"
                            value={botType}
                            label="Select Bot Type"
                            onChange={e => {
                                const selectedType = e.target.value;
                                console.log("Selected Bot Type:", selectedType);
                                setBotType(selectedType);
                            }}
                        >
                            <MenuItem value={"all"}>All</MenuItem>
                            <MenuItem value={"promotional"}>Promotional</MenuItem>
                            <MenuItem value={"transactional"}>Transactional</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                {/* checkbox 1 */}
                <Grid item xs={12} sm={6} md={4} lg={2}>
                    {/* <input
                        type="checkbox"
                        onChange={() => {
                            setOnlyButtonClickReport(!onlyButtonClickReport);
                        }}
                        style={{ width: "20px", height: "20px" }}
                        value={onlyButtonClickReport ? true : false}
                        name="onlyButtonClickReport"
                    // checked={onlyButtonClickReport}

                    /> */}

                    <FormControlLabel
                        control={
                            <Checkbox
                                disabled={false}
                                checked={onlyButtonClickReport}
                                onChange={() => setOnlyButtonClickReport(!onlyButtonClickReport)}
                                name="onlyButtonClickReport"
                                size={"small"}
                            />
                        }
                        label="Only button click report"
                        sx={{ width: "100%" }}
                    />
                </Grid>

                {/* checkbox 2 */}
                <Grid item xs={12} sm={6} md={4} lg={2}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                disabled={false}
                                checked={onlyReplyReport}
                                onChange={() => setOnlyReplyReport(!onlyReplyReport)}
                                name="onlyReplyReport"
                                size={"small"}
                            />
                        }
                        label="Only reply report"
                        sx={{ width: "100%" }}
                    />
                </Grid>
            </Grid>
            {/* filters */}

            {/* </Card> */}
            <Card sx={{ height: "61vh" }}>
                {/* {campaignReportState.controls.isGetBotConversationLogsReportLoading ? (
                    <FetchingSpinner />
                ) : campaignReportState.botConversationLogsReportDetails && campaignReportState.botConversationLogsReportDetails.length > 0 ? ( */}
                <Grid container height={"61vh"}>
                    <Grid
                        item
                        md={3}
                        minHeight={"100%"}
                        height={"100%"}
                        sx={{
                            borderRight: "1px solid grey",
                        }}
                    >
                        <BotsList botList={state.verifiedBotListForAPIReports} onSelectBot={onSelectBot} selectedBot={selectedBot} />
                    </Grid>
                    <Grid
                        item
                        md={3}
                        height={"61vh"}
                        sx={{
                            borderRight: "1px solid grey",
                        }}
                    >
                        <UsersList
                            selectedUserNumber={selectedUserNumber}
                            usersList={usersList}
                            selectedBot={selectedBot}
                            botId={selectedBot}
                            loading={loading}
                            onSelectUser={onSelectUser}
                            numberListOfUser={numberListOfUser}
                            setSearchValue={setSearchValue}
                            searchValue={searchValue}
                            startDate={executedAtStartDate}
                            endDate={executedAtEndDate}
                            onScrollTop={onScrollTop}
                            onlyButtonClickReport={onlyButtonClickReport}
                            onlyReplyReport={onlyReplyReport}
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        // sx={{
                        //     border: "1px solid grey",
                        // }}
                    >
                        <UserChats
                            selectedUserDetails={selectedUserDetails}
                            selectedBotId={selectedBot?.config?.rbmClientId}
                            selectedUserNumber={selectedUserNumber}
                            botDetails={selectedBot}
                            loadingMessage={loadingMessage}
                            pageSize={pageSize}
                            pageNumber={pageNumber}
                            setPageNumber={setPageNumber}
                            onScrollTop={onScrollTop}
                        />
                    </Grid>
                    {/* <Grid item md={4}></Grid> */}
                </Grid>
                {/* ) : (
                    <NoRecords />
                )} */}
            </Card>
        </Grid>
    );
}
